// extracted by mini-css-extract-plugin
export default {"link":"Logo_link__rUpEg","image":"Logo_image__NmziD"};